/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CompanyPaymentMethodVerificationStatus } from "./CompanyPaymentMethodVerificationStatus";
import {
  CompanyPaymentMethodVerificationStatusFromJSON,
  CompanyPaymentMethodVerificationStatusFromJSONTyped,
  CompanyPaymentMethodVerificationStatusToJSON,
  CompanyPaymentMethodVerificationStatusToJSONTyped,
} from "./CompanyPaymentMethodVerificationStatus";
import type { PaymentMethod } from "./PaymentMethod";
import {
  PaymentMethodFromJSON,
  PaymentMethodFromJSONTyped,
  PaymentMethodToJSON,
  PaymentMethodToJSONTyped,
} from "./PaymentMethod";

/**
 *
 * @export
 * @interface CompanyPaymentMethodItem
 */
export interface CompanyPaymentMethodItem {
  /**
   *
   * @type {string}
   * @memberof CompanyPaymentMethodItem
   */
  stripePaymentMethodId: string;
  /**
   *
   * @type {string}
   * @memberof CompanyPaymentMethodItem
   */
  cardholderName: string;
  /**
   *
   * @type {string}
   * @memberof CompanyPaymentMethodItem
   */
  brand: string;
  /**
   *
   * @type {string}
   * @memberof CompanyPaymentMethodItem
   */
  lastFourDigits: string;
  /**
   *
   * @type {boolean}
   * @memberof CompanyPaymentMethodItem
   */
  companyDefault: boolean;
  /**
   *
   * @type {string}
   * @memberof CompanyPaymentMethodItem
   */
  expiry?: string | null;
  /**
   *
   * @type {PaymentMethod}
   * @memberof CompanyPaymentMethodItem
   */
  paymentMethod: PaymentMethod;
  /**
   *
   * @type {CompanyPaymentMethodVerificationStatus}
   * @memberof CompanyPaymentMethodItem
   */
  verificationStatus?: CompanyPaymentMethodVerificationStatus | null;
  /**
   *
   * @type {LocalDate}
   * @memberof CompanyPaymentMethodItem
   */
  microdepositArrivalDate?: LocalDate | null;
}

/**
 * Check if a given object implements the CompanyPaymentMethodItem interface.
 */
export function instanceOfCompanyPaymentMethodItem(
  value: object,
): value is CompanyPaymentMethodItem {
  if (
    !("stripePaymentMethodId" in value) ||
    value["stripePaymentMethodId"] === undefined
  )
    return false;
  if (!("cardholderName" in value) || value["cardholderName"] === undefined)
    return false;
  if (!("brand" in value) || value["brand"] === undefined) return false;
  if (!("lastFourDigits" in value) || value["lastFourDigits"] === undefined)
    return false;
  if (!("companyDefault" in value) || value["companyDefault"] === undefined)
    return false;
  if (!("paymentMethod" in value) || value["paymentMethod"] === undefined)
    return false;
  return true;
}

export function CompanyPaymentMethodItemFromJSON(
  json: any,
): CompanyPaymentMethodItem {
  return CompanyPaymentMethodItemFromJSONTyped(json, false);
}

export function CompanyPaymentMethodItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyPaymentMethodItem {
  if (json == null) {
    return json;
  }
  return {
    stripePaymentMethodId: json["stripePaymentMethodId"],
    cardholderName: json["cardholderName"],
    brand: json["brand"],
    lastFourDigits: json["lastFourDigits"],
    companyDefault: json["companyDefault"],
    expiry: json["expiry"] == null ? undefined : json["expiry"],
    paymentMethod: PaymentMethodFromJSON(json["paymentMethod"]),
    verificationStatus:
      json["verificationStatus"] == null
        ? undefined
        : CompanyPaymentMethodVerificationStatusFromJSON(
            json["verificationStatus"],
          ),
    microdepositArrivalDate:
      json["microdepositArrivalDate"] == null
        ? undefined
        : json["microdepositArrivalDate"],
  };
}

export function CompanyPaymentMethodItemToJSON(
  json: any,
): CompanyPaymentMethodItem {
  return CompanyPaymentMethodItemToJSONTyped(json, false);
}

export function CompanyPaymentMethodItemToJSONTyped(
  value?: CompanyPaymentMethodItem | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    stripePaymentMethodId: value["stripePaymentMethodId"],
    cardholderName: value["cardholderName"],
    brand: value["brand"],
    lastFourDigits: value["lastFourDigits"],
    companyDefault: value["companyDefault"],
    expiry: value["expiry"],
    paymentMethod: PaymentMethodToJSON(value["paymentMethod"]),
    verificationStatus: CompanyPaymentMethodVerificationStatusToJSON(
      value["verificationStatus"],
    ),
    microdepositArrivalDate: value["microdepositArrivalDate"],
  };
}
